import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-header" }
const _hoisted_2 = { class: "user-name" }
const _hoisted_3 = { class: "followers" }
const _hoisted_4 = { class: "value" }
const _hoisted_5 = { class: "label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["social-card card", _ctx.socialColor])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", {
        class: _normalizeClass(["logo", _ctx.social.SocialNetworkLogo])
      }, null, 2),
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.social.Username), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.formatNumber(_ctx.social.Followers)), 1),
      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.social.FollowersDisplay), 1)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["change", _ctx.followersChangeStyle])
    }, [
      _createElementVNode("span", {
        class: _normalizeClass(["icon", _ctx.followersChangeIcon])
      }, null, 2),
      _createTextVNode(" " + _toDisplayString(Math.abs(_ctx.followersChangeAmount)) + " Today ", 1)
    ], 2)
  ], 2))
}